import { render, staticRenderFns } from "./outro.vue?vue&type=template&id=5517b622&scoped=true&"
import script from "./outro.vue?vue&type=script&lang=js&"
export * from "./outro.vue?vue&type=script&lang=js&"
import style0 from "./outro.vue?vue&type=style&index=0&id=5517b622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5517b622",
  null
  
)

export default component.exports